import React, { useState } from 'react'
import { Sidebar } from '../../../components/Sidebar/Sidebar'
import DataTable from 'react-data-table-component'
import { TiDeleteOutline } from 'react-icons/ti'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { useEffect } from 'react'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import moment from 'moment'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

export const ViewExams = () => {
  toast.configure()

  const [exams, setExams] = useState([])
  const [id, setId] = useState()

  // get already decalred exams
  const getExams = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'exam/fetchAllExams')
      .then((res) => {
        setExams(res.data.data)
      })
      .catch((error) => {})
  }

  useEffect(() => {
    getExams()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // delete particular exam
  const deleteExam = async (id) => {
    await axios
      .post(Baseurl.nodeLocal + 'exam/deleteExam', {
        exam_id: id,
      })
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
  }

  // columns to display data
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.exam_id,
      sortable: true,
      width: '80px',
    },

    {
      name: 'Exam Title',
      selector: (row) => {
        return (
          <Tippy content={row.exam_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.exam_name}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Exam Added Date',
      selector: (row) => {
        return (
          <Tippy content={row.exam_declared_date} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.exam_declared_date}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Exam Duration',
      selector: (row) => {
        var d = moment.duration(row.duration, 'milliseconds')
        var hours = Math.floor(d.asHours())
        var mins = Math.floor(d.asMinutes()) - hours * 60
        return (
          <p>
            {hours ? (hours, ' ', 'hour(s)') : ''}
            {mins ? (mins, ' ', 'minute(s)') : ''}
          </p>
        )
      },
      width: '150px',
    },
    {
      name: 'Total Questions',
      selector: (row) => row.total_que,
    },
    {
      name: 'Total Marks',
      selector: (row) => row.tot_marks,
    },
    {
      name: 'Passing Marks',
      selector: (row) => row.passing_marks,
    },

    {
      name: 'Action',
      cell: (row) => (
        <>
          <TiDeleteOutline
            className="deletebtn"
            onClick={() => {
              setId(row.exam_id)
            }}
            data-bs-target="#deletemodal"
            data-bs-toggle="modal"
          />
        </>
      ),
    },
  ]

  return (
    <div className=" row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-9 mx-5 mt-4 p-2">
        {/* breadcrumbs */}
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                View Exams
              </li>
            </ol>
          </nav>
        </div>
        <div className="viewExamheader">
          <h4>View Exams</h4>
          <Link to="/addexam" className="link">
            <div className="addExamBtn">
              <button className="btn btn-primary ">Add new Exam</button>
            </div>
          </Link>
        </div>
        {/* data table */}
        <div className="exam mt-5">
          <DataTable
            columns={columns}
            data={exams}
            pagination
            highlightOnHover
          />
        </div>
      </div>
      {/* modal for comfimartion of exam deletion */}
      <div
        className="modal"
        tabIndex="-1"
        id="deletemodal"
        aria-labelledby="#deletemodalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete the data ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  deleteExam(id)
                }}
                data-bs-dismiss="modal"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
